import { OptionDescription } from './option.type';
import { EGender } from '../enums/gender.enum';

export type GenderRecord = Record<EGender, OptionDescription<EGender>>;
